<app-rhero-page-header
  [eyebrow]="bookingHistoryMainType === helper.BookingHistoryMainType.COMPLETED ? 'Reports' : 'Bookings'"
  [title]="bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING ? 'Running' : bookingHistoryMainType === helper.BookingHistoryMainType.SCHEDULED ? 'Scheduled' : bookingHistoryMainType === helper.BookingHistoryMainType.CANCELLED ? 'Cancelled' : 'Completed'">
</app-rhero-page-header>
<div class="row">
  <div class="col-12" id="filter-height">
    <div class="card">
      <div class="card-body">
        <div class="row align-items-end row-gap-2">
          <div class="col-xxl-2 col-xl-3 col-sm-4">
            <label for="booking-history-country-selection" class="form-label mb-2">{{ "label-title.city" | translate
              }}</label>
            <ng-select id="booking-history-country-selection" appearance="outline" #agreeSelect [searchable]="true"
              placeholder="{{ 'label-title.city' | translate }}" [clearable]="false" [(ngModel)]="bookingHistoryCityId"
              (change)="onBookingHistoryCountryChange()">
              @for (city of bookingHistoryCityList; track $index) {
              <ng-option [value]="city._id">{{ city.name }}</ng-option>
              }
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-2 px-2 mt-0">
            <label for="booking-business-type" class="col-sm-auto col-form-label pt-0">{{ "heading-title.business-type"
              | translate }}</label>
            <ng-select id="booking-business-type" appearance="outline" #agreeSelect [searchable]="true"
              placeholder="{{ 'label-title.select-business-type' | translate }}" [clearable]="false"
              (change)="onBusinessTypeChange()" [(ngModel)]="selectedBusinessType">
              @for (businessType of BusinessTypeArray; track $index) {
              <ng-option [value]="businessType.key">{{ businessType.string | translate | rheroBusiness }}</ng-option>
              }
            </ng-select>
          </div>
          <div class="col-xl-4 col-sm-8 my-md-0 my-2">
            <div class="search-box">
              <input type="text" name="searchTerm" class="form-control" id="booking-history-search"
                [(ngModel)]="searchText" (keyup.enter)="onSearch()"
                placeholder="{{ 'label-title.search-for-id-name-contactinfo' | translate }}" autocomplete="off" />
              <em class="ri-search-line search-icon"></em>
              <a href="javascript:void(0);" class="clear-icon" *ngIf="searchText" (click)="clearSearch()">
                <em class="mdi mdi-close-circle-outline"></em>
              </a>
            </div>
          </div>
          <div class="col-xl-auto ms-xl-auto ms-0 col-12 d-flex gap-xl-5 gap-2 justify-content-between">
            <div class="hstack gap-2">
              @if (helper.hasPermission(helper.Permissions.EXPORT)) {
              <button type="button" class="btn btn-soft-info export-btn waves-effect waves-light material-shadow-none"
                href="javascript:void(0);" (click)="openExportModal()" id="booking-history-export-modal">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 9.55556C15 11.8889 13.4444 15.7778 8 15.7778C2.55556 15.7778 1 11.8889 1 9.55556"
                    stroke="#299CDB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00293 1.03912V11.8889" stroke="#299CDB" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M3.33301 5.66667L7.99967 1L12.6663 5.66667" stroke="#299CDB" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ "label-title.export" | translate }}
              </button>
              }
              <!-- <button type="button" class="btn btn-soft-danger waves-effect waves-light material-shadow-none" href="javascript:void(0);" id="booking-history-import-modal">
                          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M1 7.22221C1 4.88888 2.55555 0.999993 8 0.999993C13.4444 0.999992 15 4.88888 15 7.22221"
                              stroke="#F06548"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path d="M7.99707 15.7386L7.99707 4.88884" stroke="#F06548" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.667 11.1111L8.00033 15.7778L3.33366 11.1111" stroke="#F06548" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          {{ "label-title.import" | translate }}
                        </button> -->
              <button type="button" id="user-filter-modal"
                class="btn btn-soft-success waves-effect waves-light material-shadow-none" data-bs-toggle="offcanvas"
                href="javascript:void(0);" (click)="openFilterModal()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3.59852 10.4996C3.8455 9.79966 4.50708 9.33154 5.24935 9.33154C5.99162 9.33154 6.6532 9.79966 6.90018 10.4996L12.8327 10.4996V11.6663H6.90018C6.6532 12.3663 5.99162 12.8344 5.24935 12.8344C4.50708 12.8344 3.8455 12.3663 3.59852 11.6663L1.16602 11.6663V10.4996H3.59852ZM7.09852 6.41663C7.3455 5.71665 8.00708 5.24854 8.74935 5.24854C9.49162 5.24854 10.1532 5.71665 10.4002 6.41663H12.8327V7.5833H10.4002C10.1532 8.28328 9.49162 8.75139 8.74935 8.75139C8.00708 8.75139 7.3455 8.28328 7.09852 7.5833H1.16602V6.41663H7.09852ZM3.59852 2.33313C3.8455 1.63316 4.50708 1.16504 5.24935 1.16504C5.99162 1.16504 6.6532 1.63316 6.90018 2.33314L12.8327 2.33313V3.4998H6.90018C6.6532 4.19978 5.99162 4.6679 5.24935 4.6679C4.50708 4.6679 3.8455 4.19978 3.59852 3.4998L1.16602 3.4998V2.33313H3.59852ZM5.24935 3.49967C5.57151 3.49967 5.83268 3.23851 5.83268 2.91634C5.83268 2.59418 5.57152 2.33301 5.24935 2.33301C4.92718 2.33301 4.66602 2.59417 4.66602 2.91634C4.66601 3.2385 4.92718 3.49967 5.24934 3.49967H5.24935ZM8.74935 7.58317C9.07151 7.58317 9.33268 7.322 9.33268 6.99984C9.33268 6.67767 9.07152 6.41651 8.74935 6.4165C8.42718 6.4165 8.16602 6.67767 8.16602 6.99983C8.16601 7.322 8.42718 7.58317 8.74934 7.58317H8.74935ZM5.24935 11.6667C5.57151 11.6667 5.83268 11.4055 5.83268 11.0833C5.83268 10.7612 5.57152 10.5 5.24935 10.5C4.92718 10.5 4.66602 10.7612 4.66602 11.0833C4.66601 11.4055 4.92718 11.6667 5.24934 11.6667H5.24935Z"
                    fill="#00BD9D" />
                </svg>
                {{ "label-title.filters" | translate }}
              </button>
            </div>
            <div class="hstack gap-2">
              <div class="dropdown mr-2" ngbDropdown style="height: 100%">
                <span class="text-muted text-small">{{ "label-title.per-page" | translate }} : </span>
                <button class="btn btn-soft-secondary btn-sm dropdown arrow-none" id="bookin-history-page-per-view"
                  type="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle style="height: 100%">
                  {{ itemsPerPage }}
                </button>
                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                  @for (item of itemOptionsPerPage; track $index) {
                  <li class="c-pointer">
                    <a [ngClass]="item === itemsPerPage ? 'dropdown-item active' : 'dropdown-item'"
                      (click)="onChangeItemsPerPage(item)" id="page-per-view-{{ $index }}">{{
                      item
                      }}</a>
                  </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        @if (appliedFiltersLabels.length > 0) {
        <app-applied-filter-details [filterData]="filterData" [appliedFiltersLabels]="appliedFiltersLabels"
          [isBroderBottom]="true" (clearFilterEvent)="clearFilter($event)"></app-applied-filter-details>
        }
        <ul ngbNav #nav="ngbNav" [activeId]="activeBookingTab"
          class="nav nav-tabs nav-tabs-custom nav-secondary table-card mb-3 pt-2" style="padding-left: 16px"
          id="nav-tab-height">
          <li [ngbNavItem]="0" id="tab-type-all">
            <a ngbNavLink (click)="onTabClicked('all')">
              <span class="d-sm-block">{{ "label-title.all" | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabContent"></ng-template>
            </ng-template>
          </li>
          @for (item of bookingHistoryBookingTypeArray; track $index) {
          <li [ngbNavItem]="$index + 1" id="tab-type-{{ item.key }}">
            <a ngbNavLink (click)="onTabClicked(item.key)">
              <span class="d-sm-block">{{ item.string | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="TabContent"></ng-template>
            </ng-template>
          </li>
          }
        </ul>
        <div class="tab-content text-muted">
          <div [ngbNavOutlet]="nav"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #TabContent>
  <div class="table-card mb-3 table-responsive custom-scroll-height"
    [ngClass]="{ 'height-fit-content': bookingHistoryList.length === 0 }">
    <table class="table align-middle table-nowrap mb-0" id="ticketTable" aria-describedby="user-list-table">
      <thead class="thead-sticky table-light">
        <tr>
          @for (column of allColumns; track $index) { @if (!column.isHidden) { @if(column.isExtra){
          <th [id]="'user-' + column.key" [contextMenu]="column.isExtra ? basicMenu : undefined"
            (contextmenu)="openContextMenu($event)" style="cursor: unset">
            {{ column.label | translate }}
            <context-menu #basicMenu>
              @if (isExtraColumnAvailable()) {
              <ng-template contextMenuItem let-item (execute)="openAddColumnModal($index)"><span>{{
                  "label-title.before-add-column" | translate }}</span>
              </ng-template>
              <ng-template contextMenuItem let-item (execute)="openAddColumnModal($index + 1)"><span>{{
                  "label-title.after-add-column" | translate }}</span>
              </ng-template>
              }
              <ng-template contextMenuItem let-item (execute)="removeColumn($index)"><span>{{
                  "label-title.remove-column" | translate }}</span>
              </ng-template>
            </context-menu>
          </th>
          }@else{
          <th [id]="'user-' + column.key" [ngClass]="[
              column.isSort ? 'sort c-pointer' : '',
              sortItem == column.key && sortOrder == 1 ? 'active' : '',
              sortItem == column.key && sortOrder == -1 ? 'deactive' : ''
            ]" (click)="column.isSort ? onSort(column.key) : ''">
            {{ column.label | translate }}
          </th>
          } } }

          <th class="sort action-sort-hide" id="customer-action">{{ "label-title.action" | translate }}</th>
          <th class="addcolumnth bg-light" id="open-booking-add-column-modal">
            <a href="javascript:void(0);" (click)="openAddColumnModal(getAddedColumnsLength())">
              <span [placement]="helper.tooltipPlacementLeft" ngbTooltip="{{ 'label-title.add-column' | translate }}">
                |<em class="ri-add-line align-bottom"></em>| </span>
            </a>
          </th>
        </tr>
      </thead>
      <tbody class="list form-check-all" id="ticket-list-data">
        @for ( data of bookingHistoryList | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage,
        totalItems: totalPage * itemsPerPage}; track $index) {
        <tr id="t_{{ data._id }}">
          @for (column of allColumns; track $index) { @if (!column.isHidden) {
          <td>
            @if (column.isDecimal) {
            <span class="d-flex currency-gap">
              @if(getBookingNestedValue(data, column.key) !== undefined && getBookingNestedValue(data, column.key) !==
              null){
              {{ getBookingNestedValue(data, column.key)?.toFixed(data.decimalPointValue ??
              data.bookingInvoice?.decimalPointValue) }}
              @if (column.isCurrencySign) {
              <span
                [ngClass]="{ 'order-first': data.setCurrencySign ?? data.bookingInvoice?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ data.bookingInvoice?.currencySign }}
              </span>
              } } @else{ - }
            </span>
            } @else if(column.isMeterDistance){
            {{ getBookingNestedValue(data, column.key) ? getDistanceString(data, getBookingNestedValue(data,
            column.key)) : "-" }}
            } @else if(column.isSecondTime){
            {{ getBookingNestedValue(data, column.key) ? getTimeString(data, getBookingNestedValue(data, column.key)) :
            "-" }}
            } @else if(column.isRate){
            <span class="star-rating">
              @if (getBookingNestedValue(data, column.key)) { @for(star of [].constructor(getBookingNestedValue(data,
              column.key)); track $index) {
              <i-feather name="star" class="text-secondary rate-dimension"></i-feather>
              } @for(star of [].constructor(5 - getBookingNestedValue(data, column.key)); track $index) {
              <i-feather name="star" class="text-muted rate-dimension"></i-feather>
              } } @else { - }
            </span>
            } @else if(column.isDate){
              {{ 
                helper.moment(getBookingNestedValue(data, column.key))
                .tz(data.timezone)
                .format(helper.DATE_FORMAT.DD_MM_YY) 
              }} 
              {{ 
                helper.moment(getBookingNestedValue(data, column.key))
                .tz(data.timezone)
                .format(data.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) 
              }}
            } @else if(column.key == "quickCommerce.status"){
              <span
                class="badge"
                [ngClass]="{
                  'bg-info-subtle text-info':
                    data.quickCommerce.status === helper.BookingStatus.ASSIGNED ||
                    data.quickCommerce.status === helper.BookingStatus.IN_ROUTE ||
                    data.quickCommerce.status === helper.BookingStatus.PICKER_ASSIGNED ||
                    data.quickCommerce.status === helper.BookingStatus.ARRIVED_NEAR_DESTINATION ||
                    data.quickCommerce.status === helper.BookingStatus.REQUESTED ||
                    data.quickCommerce.status === helper.BookingStatus.MERCHANT_PREPARING,
                  'bg-success-subtle text-success':
                    data.quickCommerce.status === helper.BookingStatus.ACCEPTED ||
                    data.quickCommerce.status === helper.BookingStatus.ARRIVED_AT_DESTINATION ||
                    data.quickCommerce.status === helper.BookingStatus.PICKER_ACCEPTED ||
                    data.quickCommerce.status === helper.BookingStatus.PICKER_COMPLETED ||
                    data.quickCommerce.status === helper.BookingStatus.PICKED ||
                    data.quickCommerce.status === helper.BookingStatus.MERCHANT_ACCEPTED ||
                    data.quickCommerce.status === helper.BookingStatus.MERCHANT_COMPLETED ||
                    data.quickCommerce.status === helper.BookingStatus.SERVICE_COMPLETED,
                  'bg-primary-subtle text-primary':
                    data.quickCommerce.status === helper.BookingStatus.ARRIVED_AT_PICKUP ||
                    data.quickCommerce.status === helper.BookingStatus.STARTED ||
                    data.quickCommerce.status === helper.BookingStatus.ARRIVED_AT_STOP,
                  'bg-danger-subtle text-danger':
                    data.quickCommerce.status === helper.BookingStatus.NO_DRIVER_FOUND ||
                    data.quickCommerce.status === helper.BookingStatus.NOT_ANSWERED ||
                    data.quickCommerce.status === helper.BookingStatus.REJECTED ||
                    data.quickCommerce.status === helper.BookingStatus.NO_PICKER_FOUND ||
                    data.quickCommerce.status === helper.BookingStatus.PICKER_NOT_ANSWERED ||
                    data.quickCommerce.status === helper.BookingStatus.PICKER_REJECTED ||
                    data.quickCommerce.status === helper.BookingStatus.MERCHANT_REJECTED ||
                    data.quickCommerce.status === helper.BookingStatus.CANCELLED
                }"
                >{{ getStatusString(data.quickCommerce.status) | translate }}
              </span>
              } @else if(column.key == "status"){
              <span
                class="badge"
                [ngClass]="{
                  'bg-info-subtle text-info':
                    data.status === helper.BookingStatus.ASSIGNED ||
                    data.status === helper.BookingStatus.IN_ROUTE ||
                    data.status === helper.BookingStatus.PICKER_ASSIGNED ||
                    data.status === helper.BookingStatus.ARRIVED_NEAR_DESTINATION ||
                    data.status === helper.BookingStatus.REQUESTED ||
                    data.status === helper.BookingStatus.MERCHANT_PREPARING,
                  'bg-success-subtle text-success':
                    data.status === helper.BookingStatus.ACCEPTED ||
                    data.status === helper.BookingStatus.ARRIVED_AT_DESTINATION ||
                    data.status === helper.BookingStatus.PICKER_ACCEPTED ||
                    data.status === helper.BookingStatus.PICKER_COMPLETED ||
                    data.status === helper.BookingStatus.PICKED ||
                    data.status === helper.BookingStatus.MERCHANT_ACCEPTED ||
                    data.status === helper.BookingStatus.MERCHANT_COMPLETED ||
                    data.status === helper.BookingStatus.SERVICE_COMPLETED,
                  'bg-primary-subtle text-primary':
                    data.status === helper.BookingStatus.ARRIVED_AT_PICKUP || data.status === helper.BookingStatus.STARTED || data.status === helper.BookingStatus.ARRIVED_AT_STOP,
                  'bg-danger-subtle text-danger':
                    data.status === helper.BookingStatus.NO_DRIVER_FOUND ||
                    data.status === helper.BookingStatus.NOT_ANSWERED ||
                    data.status === helper.BookingStatus.REJECTED ||
                    data.status === helper.BookingStatus.NO_PICKER_FOUND ||
                    data.status === helper.BookingStatus.PICKER_NOT_ANSWERED ||
                    data.status === helper.BookingStatus.PICKER_REJECTED ||
                    data.status === helper.BookingStatus.MERCHANT_REJECTED ||
                    data.status === helper.BookingStatus.CANCELLED
                }"
                >{{ getStatusString(data.status) | translate }}
              </span>
              @if (data.isPaused) {
              <span class="badge bg-warning-subtle text-warning ms-1">{{ "label-title.paused" | translate }}</span>
              }
              } @else if(column.key == "bookingInvoice.paymentMode"){
              {{ getPaymentModeString(data.bookingInvoice?.paymentMode) || "-" | translate }}
              } @else if (column.key === 'bookingTags') { @for (item of getBookingTagsString(data.bookingTags); track $index) { @if (item) {
                <span
                  class="badge bg-theme mb-1"
                  [ngStyle]="{ color: helper.getBookingTagColor(item.tag), 'border-color': helper.getBookingTagColor(item.tag), 'border-width': '1px', 'border-style': 'solid' }"
                >
                  {{ item.string }}
                </span>
                }
              <br />
              } @empty { - } } @else if(column.key == "bookingType"){
              {{ getBookingTypeString(data.bookingType) | translate }}
              } @else if(column.key == "createdType"){
              {{ helper.UserTypeString[data.createdType] ? (helper.UserTypeString[data.createdType] | translate) : "-" }}
              } @else if(column.key == "cancelledBy"){
              {{ helper.UserTypeString[data.cancelledBy] ? (helper.UserTypeString[data.cancelledBy] | translate) : "-" }}
              } @else if(column.key == "bookingInvoice.paymentStatus"){
              <!-- On the CANCELLED list, getDisplayedPaymentStatus swaps in the newest gateway attempt's
                   status when that attempt did not complete; every other tab gets the invoice status. -->
              <span
                id="payment-status"
                class="badge bg-primary fs-11"
                [ngClass]="{
                  'bg-warning-subtle text-warning':
                    getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.PENDING ||
                    getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.CAPTURE_REQUIRED,
                  'bg-info-subtle text-info': getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.INITIATED,
                  'bg-success-subtle text-success': getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.PAID,
                  'bg-primary-subtle text-primary': getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.PAY_LATER,
                  'bg-danger-subtle text-danger':
                    getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.FAILED || getDisplayedPaymentStatus(data) === helper.PaymentTransactionStatus.CANCELLED
                }"
                >{{ helper.PaymentTransactionStatusString[getDisplayedPaymentStatus(data)] | translate }}
              </span>
              @if (isLastPaymentAttemptIncomplete(data) && data.paymentAttempts.failed > 0) {
              <span class="text-danger fs-11 ms-1">({{ data.paymentAttempts.failed }})</span>
              }
              } @else if(column.key === "isDispatched"){
              <!-- Dispatched = the booking was offered to at least one driver before it ended;
                   "No" means it was cancelled without any driver ever being requested. -->
              <span class="badge fs-11" [ngClass]="data.isDispatched ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'">
                {{ (data.isDispatched ? "label-title.yes" : "label-title.no") | translate }}
              </span>
              } @else if(column.key === "destinationAddresses[0].address") {
              {{ data.destinationAddresses[0]?.address || "-" }}
              } @else {
              {{ getBookingNestedValue(data, column.key) || "-" }}
              }
            </td>
          } }

          <!-- --------------------------------------- Action Button Started --------------------------------------- -->
          <td>
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-soft-secondary btn-sm dropdown arrow-none" id="booking-dropdown" type="button"
                data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                <em class="ri-more-fill align-middle"></em>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <li class="c-pointer">
                  <a class="dropdown-item edit-item-btn" data-bs-toggle="modal" id="view-booking"
                    (click)="openBookingDetailsModal(data._id)">
                    <em class="ri-eye-fill align-bottom me-2 text-muted float-start"></em>
                    {{ "button-title.view" | translate }}
                  </a>
                </li>
                
                <ng-container *ngFor="let action of getAvailableBookingActions(data)">
                  <li class="c-pointer">
                    <a class="dropdown-item edit-item-btn text-ellipsis mb-0" data-bs-toggle="modal" id="view-booking"
                    (click)="action.onClick()">
                      <em class="{{ action.icon }} align-bottom me-2 text-muted float-start"></em>
                        {{ action.label | translate }}
                    </a>
                  </li>
                </ng-container>
              
                
              </ul>
            </div>
          </td>
        </tr>
        } @empty { @if (showNoRecordsFound) {
        <tr>
          <th colspan="12" class="text-center" id="driver-no-records-found">
            <span>{{ "label-title.no-records-found" | translate }}</span>
          </th>
        </tr>
        } }
      </tbody>
    </table>
  </div>
</ng-template>

<app-pagination></app-pagination>

<app-booking-details-modal #bookingDetailsModal></app-booking-details-modal>
<app-export-modal #exportModal (exportDataEvent)="exportHistoryList($event)"></app-export-modal>
<app-add-column-modal (columnAddEvent)="pushedColumnUpdate($event)" #addColumnModal></app-add-column-modal>
<app-filter-data-modal (applyFilterEvent)="onFilterApplied($event)" #filterDataModal
  [filterDate]="filterData"></app-filter-data-modal>
<app-export-history-modal #exportHistoryModal></app-export-history-modal>

<app-trip-reassign-modal #reassignModal (onReassign)="reassignBooking($event)"></app-trip-reassign-modal>
<app-booking-status-change-confirmation-modal #bookingStatusChangeConfirmationModal
(changeBookingStatusEvent)="onBookingStatusChange($event)"></app-booking-status-change-confirmation-modal>
<app-booking-status-change-confirmation-quickcommerse-modal #bookingStatusChangeConfirmationModalQuickCommerse
(changeBookingStatusEvent)="onBookingStatusChange($event)"  (changeQcBookingStatusEvent)="onChangeQcBookingStatus($event)"></app-booking-status-change-confirmation-quickcommerse-modal>
<app-delivery-booking-status-change-modal (changeQcBookingStatusEvent)="onChangeQcBookingStatus($event)"  #deliveryBookingStatusChangeModal></app-delivery-booking-status-change-modal>
<app-driver-list-model #driverListModel (changeBookingStatusEvent)="onBookingStatusChange($event)" (changeQcBookingStatusEvent)="onChangeQcBookingStatus($event)"></app-driver-list-model>